import styled from "styled-components";
import { designTokens, getTypography } from "../../../styles/designTokens";

export const StartSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 140px;
  margin-top: -40px;

  @media (max-width: 768px) {
    gap: 80px;
  }
`;

export const UploadSection = styled.div<{ $isDragging: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px 40px 40px;
  gap: 40px;
  width: 100%;
  max-width: 960px;
  min-width: 600px;
  min-height: 288px;
  background: ${(props) =>
    props.$isDragging
      ? "rgba(255, 255, 255, 0.85)"
      : "rgba(255, 255, 255, 0.75)"};
  box-shadow: ${(props) =>
    props.$isDragging
      ? "0px 8px 28px rgba(58, 111, 133, 0.25)"
      : "0px 6px 20px rgba(58, 111, 133, 0.15)"};
  backdrop-filter: blur(12px);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  transform: ${(props) => (props.$isDragging ? "scale(1.02)" : "scale(1)")};

  &:hover {
    box-shadow: 0px 8px 28px rgba(92, 110, 255, 0.25);
  }
`;

export const UploadButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 50%;
  background: linear-gradient(135deg, #5c6eff, #7385ff);
  color: #fff;
  cursor: pointer;
  transition: all 0.25s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(92, 110, 255, 0.4);
  }

  &:active {
    transform: translateY(1px);
  }

  svg {
    width: 22px;
    height: 22px;
  }
`;

export const UploadTitle = styled.div`
  ${getTypography("korean", "body2")}
  color: ${designTokens.colors.font.primary};
  font-weight: 500;
  text-align: center;
`;

export const UploadSubtitle = styled.div`
  ${getTypography("korean", "body4")}
  color: ${designTokens.colors.font.tertiary};
  text-align: center;
  margin-top: -8px;
`;
